



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import user_SidebarMainInfo from './SidebarMainInfo.vue';
import { types } from '../../api_types';

@Component({
  components: {
    'omegaup-user-maininfo': user_SidebarMainInfo,
  },
})
export default class ProfileWrapper extends Vue {
  @Prop({ default: null }) data!: types.ExtraProfileDetails | null;
  @Prop() profile!: types.UserProfileInfo;
  @Prop({ default: null }) selectedTab!: null | string;
  @Prop() hasPassword!: boolean;

  currentSelectedTab = this.selectedTab;

  @Watch('currentSelectedTab')
  onCurrentSelectedTabChanged(newValue: string) {
    this.$emit('update:selectedTab', newValue);
  }
}
